export default __webpack_public_path__ + "static/media/ourstory.430813e3.png";